globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};
appCustomerSpace.Modules.LocalManagement = appCustomerSpace.Modules.LocalManagement || {};

appCustomerSpace.Modules.LocalManagement.CompanyProfileScreenshot = (function() {

  function CompanyProfileScreenshot() {}

  CompanyProfileScreenshot.request = function($container) {
    ajaxUrl = $container.data("ajax-url"),

    appCustomerSpace.Loader().start({
      $container: $container,
      options: {
        text: appCustomerSpace.lang.t('company_profile.refresh_screenshot')
      }
    });

    if(ajaxUrl) {
      $.ajax({
        url: ajaxUrl,
        method: "POST",
        success: function(data) {
          if(data.response == 1 && data.screenshot) {
            appCustomerSpace.Loader().stop({ $container: $container }, function() {
              $container.find(".company-profile-thumbnail").css("background-image", "url(" + data.screenshot + ")");
              $container.removeClass("request-screenshot");
            });
          } else {
            console.log("Impossible de charger l'image")
          }
        },
        error: function() {
          console.log("Impossible de charger l'image")
        }
      })
    }
  }

  return CompanyProfileScreenshot;
})();
